'use es6';

import { parse } from 'hub-http/helpers/params';
export default (() => parse(window.location.search.replace('?', '').replace(/\+/g, ' ')));